class Validator {

  constructor(options) {
    this.validationOptions = typeof options.validationOptions !== 'undefined' ? options.validationOptions : {};
    this.data = typeof options.data !== 'undefined' ? options.data : {};
  }

  _validate(options, value) {
    let type = options;
    let pass = true;
    let message = "";
    if ( typeof options === "object" ) {
      type = options.type;
    }
    switch (type) {
      case "email":
        pass = value !== '' ? /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) : true;
        if ( !pass ) {
          message = "Invalid email address.";
        }
        break;
      case "max":
        pass = value.length <= options.value;
        if ( !pass ) {
          message = "Value must not longer then " + options.value + " character(s).";
        }
        break;
      case "required":
        pass = value !== '' && value !== null;
        if ( !pass ) {
          message = "This field is required.";
        }
        break;
      case "number":
        pass = !isNaN(value);
        if ( !pass ) {
          message = "Must be a number.";
        }
        break;
      case "gt":
        pass = value > options.value;
        if ( !pass ) {
          message = `Value must be greater than ${options.value}.`;
        }
        break;
      case "lt":
        pass = value < options.value;
        if ( !pass ) {
          message = `Value must be less than ${options.value}.`;
        }
        break;
      case "match":
        pass = value === this.data[options.field];
        if ( !pass ) {
          message = `${options.source} and ${options.target} do not match.`;
        }
        break;
      case "custom":
        let result = options.func();
        pass = result.pass;
        if ( !pass ) {
          message = result.message || "";
        }
        break;
      default:
        break;
    }
    return { pass: pass, message: message };
  }

  _validateMultiple(rules, value) {
    let pass = true;
    let messages = [];
    if ( !Array.isArray(rules) ) {
      rules = [rules];
    }
    for (var i = 0; i < rules.length; i++) {
      let result = this._validate(rules[i], value);

      if ( !result.pass ) {
        pass = false;
        messages.push(result.message);
      }

    }
    return { pass: pass, messages: messages };
  }

  getValidaitonOptions() {
    return this.validationOptions;
  }

  validate(fields) {
    let validationOptions = this.getValidaitonOptions();
    let pass = true;
    let errors = {};
    for( let key in fields ) {
      let result = this._validateMultiple(validationOptions[key], fields[key]);
      if ( !result.pass ) {
        pass = false;
        errors[key] = result.messages;
      } else {
        errors[key] = [];
      }
    }
    return { error: !pass, messages: errors };
  }
}

export default Validator;


// WEBPACK FOOTER //
// ./src/helpers/Validator.js